export const colorCodes = [
  "hsl(301, 70%, 50%)",
  "hsl(120, 70%, 50%)",
  "hsl(345, 70%, 50%)",
  "hsl(283, 70%, 50%)",
  "hsl(103, 70%, 50%)",
];
